import { getFullUrl } from "@/lib/get-full-url";

export function buildPageMeta({
  path,
  title,
  description,
  image = "/hype-stream.png",
  type = "website",
}: {
  path: string;
  title: string;
  description: string;
  image?: string;
  type?: "website" | "article";
}) {
  const url = getFullUrl(path);
  const imageUrl = image.startsWith("http") ? image : getFullUrl(image);
  return [
    { title },
    { name: "description", content: description },
    { tagName: "link", rel: "canonical", href: url },
    { property: "og:type", content: type },
    { property: "og:url", content: url },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: imageUrl },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: imageUrl },
  ];
}
